import storeInfo from '../store'
import { DiscountsType } from './types'

export const getDiscountsValue = (type: keyof DiscountsType) => (): any => {
  const { discounts } = storeInfo.store.getState()
  return discounts[type as keyof DiscountsType]
}
